import {Injectable} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {NewDocumentService} from './new-document.service';
import {DocumentTypes} from '../definitions/document-types';
import {StateManagerService} from './state-manager.service';
import {CollectionsNames} from '../definitions/collections-names';
import {SiteModel} from '../models/site.model';
import {DocumentModel} from '../models/document.model';
import {PersistDocumentService} from './persist-document.service';

@Injectable({
    providedIn: 'root'
})
export class DocumentFromLiveDetailLineService {

    constructor(private newDocumentService: NewDocumentService,
                private documentTypes: DocumentTypes,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private persistDocumentService: PersistDocumentService) {
    }

    newCollection(liveDetailLine: DetaillineDTOModel) {
        const newDocument = this.newDocumentService.genNewDocument();
        const liveLines = JSON.parse(JSON.stringify(this.stateManager.getCollection(this.collectionNames.LIVEDETAILLINES)));
        newDocument.documentType = this.documentTypes.COLLECTION;
        newDocument.customer = this.stateManager.getCollection(this.collectionNames.CUSTOMER).find(cust => {
            return cust.id === liveDetailLine.custId;
        });
        if (liveDetailLine.site) {
            newDocument.site = this.stateManager.getCollection(this.collectionNames.SITE).find(site => {
                return site.id === liveDetailLine.site;
            });
        }
        console.log(newDocument.site);
        newDocument.detailLines = liveLines.filter(line => {
            return line.contractDocumentNumber === liveDetailLine.contractDocumentNumber
                && (line.location === liveDetailLine.location);
        });
        console.log(newDocument);
        for (const line of newDocument.detailLines) {
            line.qty = 0;
            // tslint:disable-next-line:triple-equals for sake of simplicity
            if ((line.pdesc === liveDetailLine.pdesc && line.reg === liveDetailLine.reg) && line.plu == liveDetailLine.plu) {
                line.qty = liveDetailLine.qty;
            }
        }
        // this.stateManager.upsert(this.collectionNames.DOCUMENT, '$loki', newDocument);
        this.persistDocumentService.persistDocument(newDocument);
        this.stateManager.saveDatabase();
    }
}
